import z from "zod";

import { optionalPhoneZodField } from "@/schemas/shared/phone-field-schema";
import { studentGenderFormField } from "@/schemas/shared/student-gender-field";

export const studentRegistrationSchema = z.object({
  firstName: z.string().min(1, { message: "First name is required" }),
  lastName: z.string().min(1, { message: "Last name is required" }),
  preferredName: z.string().optional(),
  birthday: z.object({
    day: z.string().min(1, { message: "Day is required" }),
    month: z.string().min(1, { message: "Month is required" }),
    year: z.string().min(1, { message: "Year is required" }),
  }),
  gender: studentGenderFormField,
  cellPhone: optionalPhoneZodField,
  homePhone: optionalPhoneZodField,
  email: z
    .string()
    .optional()
    .refine(
      (val) =>
        !val || val.trim() === "" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val),
      { message: "Please enter a valid email address" },
    ),
  address: z.string().optional(),
  locationIds: z
    .array(z.string())
    .min(1, { message: "At least one location is required" }),
  medications: z.string().optional(),
  allergies: z.string().optional(),
  specialNeeds: z.string().optional(),
  postPublicly: z.boolean().optional(),
});

export type StudentRegistrationFormSchemaType = z.infer<
  typeof studentRegistrationSchema
>;
